/* moose.lighting homepage shuffle
   The three homepage rows each render the first products of a collection, so
   every visitor would otherwise see the same items forever. This swaps in a
   fresh random handful per page load, taken from the top of each collection so
   the labels still mean something, with no product repeated across the rows.
   Runs after the theme has finished its own work, and leaves the cards alone
   if anything fails. */
(function () {
  "use strict";

  var ROWS = {
    "best-sellers":   { pool: 24,  skip: ["Accessories"] },
    "popular-picks":  { pool: 60,  skip: ["Accessories"] },
    "new-arrivals-1": { pool: 250, skip: ["Accessories"] }
  };
  var done = false;

  function handleOf(block) {
    var a = block.querySelector("h2 a, h3 a, h4 a, h5 a");
    if (!a) { return null; }
    var href = a.getAttribute("href") || "";
    var i = href.indexOf("/collections/");
    if (i < 0) { return null; }
    return href.slice(i + 13).split("?")[0].split("#")[0].replace("/", "");
  }

  function money(v) {
    var n = parseFloat(v);
    if (!isFinite(n)) { return null; }
    return "$ " + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function paint(card, p) {
    var img = card.querySelector(".product-featured__image img");
    var link = card.querySelector(".product-featured__title a");
    var price = card.querySelector(".product-featured__price");
    if (!img || !link) { return false; }
    var src = (p.images && p.images.length) ? p.images[0].src : null;
    var v = (p.variants && p.variants.length) ? p.variants[0] : null;
    if (!src || !v) { return false; }
    img.removeAttribute("srcset");
    img.removeAttribute("data-src");
    img.removeAttribute("sizes");
    img.setAttribute("src", src);
    img.setAttribute("alt", p.title);
    link.setAttribute("href", "/products/" + p.handle);
    link.textContent = p.title;
    if (price) { var m = money(v.price); if (m) { price.textContent = m; } }
    return true;
  }

  window.__mlShuffle = { runs: 0, painted: {}, err: null };

  function run() {
    if (done) { return; }
    window.__mlShuffle.runs++;
    var blocks = [].slice.call(document.querySelectorAll("[class*=home-builder-block-id]"))
      .filter(function (b) { return b.querySelector(".product-featured") && ROWS[handleOf(b)]; });
    if (!blocks.length) { return; }
    done = true;

    var used = {};
    var jobs = blocks.map(function (block) {
      var handle = handleOf(block);
      var cfg = ROWS[handle];
      return fetch("/collections/" + handle + "/products.json?limit=250", { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.products) { return; }
          var pool = data.products.slice(0, cfg.pool).filter(function (p) {
            if (used[p.handle]) { return false; }
            if (cfg.skip.indexOf(p.product_type) > -1) { return false; }
            if (!p.images || !p.images.length) { return false; }
            if (!p.variants || !p.variants.length) { return false; }
            return parseFloat(p.variants[0].price) > 0;
          });
          if (!pool.length) { return; }
          var cards = [].slice.call(block.querySelectorAll(".product-featured"));
          for (var i = 0; i < cards.length && pool.length; i++) {
            var p = pool.splice(Math.floor(Math.random() * pool.length), 1)[0];
            if (paint(cards[i], p)) { used[p.handle] = true; window.__mlShuffle.painted[handle] = (window.__mlShuffle.painted[handle] || 0) + 1; }
          }
        })
        .catch(function (e) { window.__mlShuffle.err = String(e); });
    });
    return Promise.all(jobs);
  }

  // the theme finishes its own rendering after load, so go last
  if (document.readyState === "complete") { setTimeout(run, 300); }
  else { window.addEventListener("load", function () { setTimeout(run, 300); }); }
  setTimeout(run, 2500);
})();